"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthoriserWithTrustedTexts = void 0;
const authoriser_constants_1 = require("../../../authoriser/constants/authoriser.constants");
const useAuthoriserTexts_1 = require("../useAuthoriserTexts");
const useAuthoriserWithTrustedTexts = (componentConfig) => {
    const baseTexts = (0, useAuthoriserTexts_1.useAuthoriserTexts)(componentConfig);
    return {
        ...baseTexts,
        globalErrorMessages: {
            ...baseTexts.globalErrorMessages,
            trustedDeviceRequired: authoriser_constants_1.getRequiredTrustedDeviceTexts,
        },
    };
};
exports.useAuthoriserWithTrustedTexts = useAuthoriserWithTrustedTexts;
exports.default = exports.useAuthoriserWithTrustedTexts;
//# sourceMappingURL=useAuthoriserWithTrustedTexts.hook.js.map